import { AnimatePresence } from "motion/react";
import { FC } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { AccessControl } from "@ryde/controls";
import { AddNewFormGeneric, AnimatedPage } from "@ryde/layout";
import { RydeUiUnit } from "@ryde/shared";

import { StationRouteEdit } from "./station-route.edit";

export const StationRouteCrudRoutes: FC = () => {
  const entity: RydeUiUnit = "stationRoute";

  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="new"
          element={
            <AccessControl entity={entity} action="create">
              <AnimatedPage>
                <AddNewFormGeneric entity={entity} />
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
        <Route
          path="add"
          element={
            <AccessControl entity={entity} action="create">
              <AnimatedPage>
                <StationRouteEdit isAddRoute />
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
        <Route
          path="add/:id"
          element={
            <AccessControl entity={entity} action="update">
              <AnimatedPage>
                <StationRouteEdit isAddRoute />
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
        <Route
          path="edit/:id"
          element={
            <AccessControl entity={entity} action="read">
              <AnimatedPage>
                <StationRouteEdit />
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
      </Routes>
    </AnimatePresence>
  );
};
